/**
 * Header Component
 *
 * Main application header with navigation and user controls.
 */
import { Link } from 'react-router-dom'
import ThemeToggle from '../ui/theme-toggle'
import MobileNav from './mobile-nav'
import { AuthNav } from './auth-nav'
import { cn, twStyles } from '../../utils/tailwind-utils'
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '../ui/dropdown-menu'

interface HeaderProps {
  className?: string
}

function Header({ className }: HeaderProps) {
  return (
    <header className={cn('sticky top-0 z-10 bg-card border-b border-border', className)}>
      <div className={cn(twStyles.container.base, 'py-3 flex justify-between items-center')}>
        {/* Logo and Brand */}
        <div className="flex items-center">
          <MobileNav className="mr-2" />
          <Link to="/" className="flex items-center space-x-2">
            <span className="text-xl font-bold text-primary">Boardgames Today</span>
          </Link>
        </div>

        {/* Main Navigation - Hidden on mobile */}
        <nav className="hidden md:flex items-center space-x-6">
          <NavLink to="/">Home</NavLink>
          <DropdownMenu>
            <DropdownMenuTrigger className="text-foreground hover:text-primary transition-colors">
              Meetups
            </DropdownMenuTrigger>
            <DropdownMenuContent>
              <DropdownMenuItem asChild>
                <Link to="/meetups" className="w-full">
                  All Meetups
                </Link>
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <Link to="/meetups/new" className="w-full">
                  Create Meetup
                </Link>
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <Link to="/meetups" className="w-full">
                  My Meetups
                </Link>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
          <NavLink to="/games">Games</NavLink>
          <NavLink to="/about">About</NavLink>
        </nav>

        {/* Auth Navigation and Theme Toggle */}
        <div className="flex items-center space-x-3">
          <ThemeToggle />
          <AuthNav />
        </div>
      </div>
    </header>
  )
}

interface NavLinkProps {
  to: string
  children: React.ReactNode
  className?: string
}

function NavLink({ to, children, className }: NavLinkProps) {
  return (
    <Link to={to} className={cn('text-foreground hover:text-primary transition-colors', className)}>
      {children}
    </Link>
  )
}

export default Header
